export const translations = {
  fr: {
    // Common
    common: {
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
      loading: "Chargement...",
      search: "Rechercher",
      filter: "Filtrer",
      download: "Télécharger",
      share: "Partager",
      upload: "Importer",
      confirm: "Confirmer",
      skip: "Passer",
      continue: "Continuer",
      getStarted: "Commencer",
      learnMore: "En savoir plus",
      viewAll: "Voir tout",
      manage: "Gérer",
      signIn: "Se connecter",
      signUp: "S'inscrire",
      signOut: "Se déconnecter",
      or: "ou",
      free: "Gratuit",
      perMonth: "/mois",
      perYear: "/an",
      popular: "Populaire",
      recommended: "Recommandé",
    },

    // Landing
    landing: {
      nav: {
        features: "Fonctionnalités",
        howItWorks: "Comment ça marche",
        pricing: "Tarifs",
        signIn: "Se connecter",
        getStarted: "Commencer",
        startFree: "Commencer gratuitement",
      },
      hero: {
        badge: "Propulsé par l'intelligence artificielle",
        title1: "Organisez moins.",
        title2: "Retrouvez tout.",
        subtitle: "EasyFinder centralise vos documents, les classe automatiquement et vous permet de tout retrouver en quelques secondes grâce à une recherche intelligente.",
        cta: "Essayer gratuitement",
        watchDemo: "Voir la démo",
        users: "+2 000 utilisateurs",
        reviews: "4.9/5 (150+ avis)",
        searchPlaceholder: "Où est ma déclaration d'impôts 2023 ?",
      },
      howItWorks: {
        title: "Simple comme bonjour",
        subtitle: "Trois étapes pour ne plus jamais perdre un document",
        steps: [
          { title: "Importez vos documents", desc: "Connectez Gmail, Outlook, ou déposez vos fichiers directement." },
          { title: "L'IA s'occupe du reste", desc: "Classification automatique, extraction des dates et informations clés." },
          { title: "Recherchez naturellement", desc: "\"Ma facture EDF de mars\" — et hop, le voilà." },
        ],
      },
      features: {
        title: "Tout ce qu'il vous faut",
        subtitle: "Des outils pensés pour vous faire gagner du temps",
        items: [
          { title: "Recherche intelligente", desc: "Posez une question en français, trouvez votre document." },
          { title: "Classification automatique", desc: "Factures, contrats, impôts... L'IA trie pour vous." },
          { title: "Sécurité maximale", desc: "Chiffrement de bout en bout, hébergement français." },
          { title: "Outils PDF complets", desc: "Fusionnez, annotez et signez vos documents." },
          { title: "Scanner intelligent", desc: "Photographiez, l'IA numérise et classe automatiquement." },
          { title: "Partage sécurisé", desc: "Liens protégés par mot de passe avec expiration." },
        ],
      },
      testimonials: {
        title: "Ils ont adopté EasyFinder",
        subtitle: "Découvrez pourquoi ils ne peuvent plus s'en passer",
        items: [
          { quote: "Fini les heures perdues à chercher mes factures. En 3 secondes, je trouve tout ce dont j'ai besoin.", name: "Marie L.", role: "Freelance Design" },
          { quote: "La classification automatique est bluffante. J'ai importé 500 documents, tout était trié en 2 minutes.", name: "Thomas D.", role: "Entrepreneur" },
          { quote: "Le partage sécurisé avec mes clients a transformé mon quotidien. Professionnel et efficace.", name: "Sophie M.", role: "Avocate" },
        ],
      },
      pricing: {
        title: "Un prix simple, pas de surprise",
        subtitle: "Commencez gratuitement, évoluez quand vous êtes prêt",
        mostPopular: "Le plus populaire",
        perMonth: "/mois",
        cta: "Commencer",
        cancelAnytime: "Annulez à tout moment. Économisez 20% avec l'abonnement annuel.",
        plans: [
          { name: "Découverte", desc: "Pour essayer", features: ["30 documents", "1 source connectée", "10 recherches IA/jour", "5 actions PDF/mois"] },
          { name: "Perso", desc: "Pour les particuliers", features: ["500 documents", "1 source connectée", "50 recherches IA/jour", "20 actions PDF/mois"] },
          { name: "Pro", desc: "Pour les freelances", features: ["2 500 documents", "2 sources connectées", "Recherches IA illimitées", "Actions PDF illimitées", "Export ZIP"] },
          { name: "Business", desc: "Pour les équipes", features: ["10 000 documents", "Sources illimitées", "3 utilisateurs inclus", "Gestion des rôles"] },
        ],
      },
      cta: {
        title: "Prêt à reprendre le contrôle ?",
        subtitle: "Rejoignez des milliers d'utilisateurs qui ont enfin trouvé la sérénité documentaire.",
        button: "Démarrer gratuitement",
      },
      footer: {
        securityFaq: "FAQ Sécurité",
        privacy: "Politique de confidentialité",
        terms: "Conditions",
        legal: "Mentions légales",
      },
    },

    // Auth
    auth: {
      createAccount: "Créer votre compte",
      welcomeBack: "Bon retour",
      startOrganizing: "Commencez à organiser vos documents",
      signInAccess: "Connectez-vous pour accéder à vos documents",
      fullName: "Nom complet",
      email: "Email",
      password: "Mot de passe",
      createAccountBtn: "Créer le compte",
      signInBtn: "Se connecter",
      orContinueWith: "Ou continuer avec",
      continueWithGoogle: "Continuer avec Google",
      continueWithApple: "Continuer avec Apple",
      alreadyHaveAccount: "Déjà un compte ?",
      noAccount: "Pas encore de compte ?",
      forgotPassword: "Mot de passe oublié ?",
      checkEmail: "Vérifiez votre email",
      confirmationSent: "Nous avons envoyé un lien de confirmation à",
      clickToActivate: "Cliquez sur le lien dans l'email pour activer votre compte et commencer à utiliser EasyFinder.",
      confirmedEmail: "J'ai confirmé mon email",
      noEmailReceived: "Vous n'avez pas reçu l'email ?",
      resend: "Renvoyer",
      welcomeBackToast: "Bon retour !",
      invalidCredentials: "Email ou mot de passe incorrect",
      emailInUse: "Cet email est déjà utilisé",
      confirmEmailFirst: "Veuillez confirmer votre email avant de vous connecter",
      genericError: "Une erreur est survenue",
      resendError: "Erreur lors du renvoi de l'email",
      resendSuccess: "Email de confirmation renvoyé !",
      googleNotConfigured: "Connexion Google non configurée pour l'instant",
      validation: {
        emailRequired: "L'email est requis",
        emailInvalid: "Format d'email invalide",
        emailTooLong: "L'email ne doit pas dépasser 255 caractères",
        emailFormat: "Format d'email non autorisé",
        passwordMin: "Le mot de passe doit contenir au moins 8 caractères",
        passwordMax: "Le mot de passe ne doit pas dépasser 128 caractères",
        passwordUppercase: "Le mot de passe doit contenir au moins une majuscule",
        passwordLowercase: "Le mot de passe doit contenir au moins une minuscule",
        passwordDigit: "Le mot de passe doit contenir au moins un chiffre",
        passwordSpecial: "Le mot de passe doit contenir au moins un caractère spécial",
        passwordRequired: "Le mot de passe est requis",
        nameMin: "Le nom doit contenir au moins 2 caractères",
        nameMax: "Le nom ne doit pas dépasser 100 caractères",
        nameFormat: "Le nom ne doit contenir que des lettres",
      },
    },

    // Pricing
    pricing: {
      launchOffer: "Offre de lancement : Pro à 19,90€/mois pour les 500 premiers",
      title: "Choisissez votre plan",
      subtitle: "Commencez gratuitement, évoluez selon vos besoins",
      monthly: "Mensuel",
      yearly: "Annuel",
      monthsFree: "2 mois offerts",
      mostPopular: "Le plus populaire",
      billedAnnually: "Facturé annuellement",
      saveWith: "Économisez",
      withAnnual: "/an avec l'annuel",
      documents: "Documents",
      sources: "Sources",
      aiSearchesDay: "Recherches IA/jour",
      pdfActionsMonth: "Actions PDF/mois",
      unlimited: "Illimité",
      all: "Toutes",
      moreFeatures: "autres fonctionnalités",
      currentPlan: "Plan actuel",
      startFree: "Commencer gratuitement",
      choosePlan: "Choisir ce plan",
      redirecting: "Redirection...",
      allPlansInclude: "Tous les plans incluent : chiffrement des données, support email, mises à jour automatiques",
      faq: {
        title: "Questions fréquentes",
        items: [
          { q: "Le plan Découverte est-il vraiment gratuit ?", a: "Oui ! Le plan Découverte est gratuit à vie avec 30 documents, 10 recherches IA par jour et les fonctionnalités essentielles." },
          { q: "Puis-je changer de plan à tout moment ?", a: "Absolument. Vous pouvez upgrader ou downgrader votre plan quand vous voulez. La différence sera calculée au prorata." },
          { q: "Mes données sont-elles sécurisées ?", a: "Oui, vos documents sont chiffrés et stockés de manière sécurisée. Nous sommes conformes RGPD et ne partageons jamais vos données." },
          { q: "Comment fonctionne la facturation annuelle ?", a: "Avec la facturation annuelle, vous économisez environ 2 mois. Le paiement est effectué en une fois pour l'année." },
        ],
      },
      footer: "Tous droits réservés.",
      toasts: {
        freeNoPayment: "Ce plan est gratuit, pas besoin de paiement",
        paymentUrlError: "URL de paiement non reçue",
        paymentError: "Erreur lors de la création du paiement",
      },
    },

    // Dashboard
    dashboard: {
      welcomeBack: "Bon retour",
      whatLookingFor: "Que recherchez-vous aujourd'hui ?",
      findManage: "Trouvez et gérez vos documents",
      searchPlaceholder: "Que cherchez-vous ? Essayez 'déclaration impôts 2023' ou 'factures mars'...",
      upload: "Importer",
      browseAll: "Parcourir tout",
      connectedSources: "Sources connectées",
      recentDocuments: "Documents récents",
      viewAll: "Voir tout",
      noDocuments: "Aucun document",
      uploadFirst: "Importez votre premier document pour commencer",
      welcome: "Bienvenue sur EasyFinder 🎉",
      startWithDocs: "Commencez par ajouter vos premiers documents",
      scanDocument: "Scanner un document",
      scanDesc: "Utilisez votre caméra pour numériser",
      importFiles: "Importer des fichiers",
      importDesc: "PDF, images, documents Word...",
      connectEmail: "Connecter votre email",
      connectEmailDesc: "Importez automatiquement vos pièces jointes",
      placeholders: [
        "Mes factures de plus de 500 euros",
        "Contrats signés en 2024",
        "Documents véhicule",
        "Attestations employeur",
        "Relevés bancaires récents",
      ],
      expiration: {
        expired: "Expiré depuis",
        today: "Expire aujourd'hui",
        days: "Expire dans",
        daysUnit: "j",
      },
      toasts: {
        voiceNotSupported: "La reconnaissance vocale n'est pas supportée",
        aiLimitReached: "Limite de recherches IA atteinte",
        signOutSuccess: "Déconnexion réussie",
        alertRemoved: "Alerte supprimée",
      },
    },

    // Documents
    documents: {
      allDocuments: "Tous les documents",
      searchDocuments: "Rechercher des documents...",
      type: "Type",
      source: "Source",
      category: "Catégorie",
      allTypes: "Tous les types",
      allSources: "Toutes les sources",
      allCategories: "Toutes les catégories",
      allCategoriesShort: "Toutes",
      documentsCount: "documents",
      noResults: "Aucun document trouvé",
      scanner: "Scanner",
      import: "Importer",
      alerts: "Alertes",
      cleanDuplicates: "Nettoyer doublons",
      select: "Sélectionner",
      selectAll: "Tout sélectionner",
      cancelSelection: "Annuler",
      selected: "sélectionné(s)",
      deleteSelection: "Supprimer la sélection",
      share: "Partager",
      edit: "Modifier",
      delete: "Supprimer",
      openSource: "Ouvrir la source originale",
      page: "Page",
      sessionExpired: "Session expirée, veuillez vous reconnecter",
      loadError: "Impossible de charger vos documents",
      toasts: {
        deleteFileError: "Erreur lors de la suppression des fichiers",
        deleteError: "Erreur lors de la suppression",
        deleteSuccess: "Document supprimé",
        deleteBulkSuccess: "document(s) supprimé(s)",
        downloadError: "Erreur lors du téléchargement",
        extracting: "Extraction du texte en cours...",
        extractError: "Erreur lors de l'extraction",
        extractOcrError: "Erreur lors de l'extraction OCR",
        extractSuccess: "Texte extrait avec succès !",
        noDuplicates: "Aucun doublon détecté !",
        noSelected: "Aucun doublon sélectionné",
        duplicatesDeleted: "doublon(s) supprimé(s)",
        aiSearchError: "Erreur lors de la recherche IA",
      },
      types: {
        invoice: "Facture",
        contract: "Contrat",
        tax: "Impôts",
        insurance: "Assurance",
        identity: "Identité",
        receipt: "Reçu",
        quote: "Devis",
        payslip: "Bulletin de salaire",
        attestation: "Attestation",
        bank_statement: "Relevé bancaire",
        medical_certificate: "Certificat médical",
        notarial_deed: "Acte notarié",
        administrative: "Document administratif",
        warranty: "Garantie",
        other: "Autre",
      },
      sources: {
        gmail: "Gmail",
        outlook: "Outlook",
        whatsapp: "WhatsApp",
        upload: "Import",
      },
      statuses: {
        processing: "En cours",
        complete: "Terminé",
        failed: "Échec",
        important: "Important",
        to_verify: "À vérifier",
        archived: "Archivé",
      },
    },

    // PDF Tools
    pdf: {
      pageTitle: "Outils PDF",
      viewer: "Visionneuse PDF",
      merge: "Fusionner des PDF",
      sign: "Signer un document",
      scan: "Scanner un document",
      selectFiles: "Sélectionner des fichiers",
      dragDrop: "Glissez-déposez vos fichiers ici",
      mergeDescription: "Combinez plusieurs PDF en un seul document",
      signDescription: "Ajoutez votre signature à un document",
      scanDescription: "Numérisez un document avec votre caméra",
      processing: "Traitement en cours...",
      download: "Télécharger le résultat",
      addSignature: "Ajouter une signature",
      drawSignature: "Dessinez votre signature",
      clearSignature: "Effacer",
      applySignature: "Appliquer la signature",
      capturePhoto: "Prendre la photo",
      retake: "Reprendre",
      usePhoto: "Utiliser cette photo",
      initializingScanner: "Initialisation du scanner intelligent...",
      loadingAutoDetection: "Chargement de la détection automatique",
      documentDetected: "Document détecté - Capture en cours...",
      holdSteady: "Maintenez le document stable...",
      positionDocument: "Positionnez le document dans le cadre",
      autoCaptureHint: "Le document sera capturé automatiquement une fois détecté et stable",
    },

    // Not Found
    notFound: {
      title: "Page non trouvée",
      message: "Oups ! Cette page n'existe pas",
      backHome: "Retour à l'accueil",
    },

    // Reset Password
    resetPassword: {
      title: "Nouveau mot de passe",
      subtitle: "Choisissez un mot de passe sécurisé",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Mettre à jour le mot de passe",
      submitting: "Mise à jour...",
      success: "Mot de passe mis à jour",
      successMessage: "Votre mot de passe a été modifié avec succès. Redirection en cours...",
      invalidLink: "Lien de réinitialisation invalide ou expiré",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      samePassword: "Le nouveau mot de passe doit être différent de l'ancien",
      updateError: "Une erreur est survenue lors de la mise à jour",
      updateSuccess: "Mot de passe mis à jour avec succès !",
    },


    // Onboarding
    onboarding: {
      step: "Étape",
      of: "sur",
      accountType: {
        title: "Qui utilisera EasyFinder ?",
        subtitle: "Cela détermine si vous créez une organisation partagée ou non",
        individual: {
          title: "Moi uniquement",
          desc: "Usage personnel, un seul utilisateur. Tous les plans sont disponibles.",
        },
        team: {
          title: "Mon équipe",
          desc: "Créer une organisation pour inviter des collaborateurs et partager des documents.",
        },
      },
      organization: {
        title: "Créer votre organisation",
        subtitle: "Ces informations seront visibles par les membres de votre équipe",
        name: "Nom de l'organisation",
        namePlaceholder: "Mon entreprise",
        domain: "Domaine (optionnel)",
        domainPlaceholder: "monentreprise.com",
        logo: "Logo (optionnel)",
        uploadLogo: "Importer un logo",
      },
      plan: {
        title: "Choisissez votre plan",
        subtitle: "Commencez gratuitement, évoluez selon vos besoins",
        monthly: "Mensuel",
        yearly: "Annuel",
        yearlyDiscount: "2 mois offerts",
        currentPlan: "Plan actuel",
        choosePlan: "Choisir ce plan",
        startFree: "Commencer gratuitement",
      },
      sources: {
        title: "Connectez vos sources",
        subtitle: "Importez automatiquement vos documents depuis vos services",
        emailCategory: "Emails",
        cloudCategory: "Stockage cloud",
        otherCategory: "Autres sources",
        gmail: {
          title: "Gmail",
          desc: "Importer les pièces jointes de vos emails",
        },
        outlook: {
          title: "Outlook",
          desc: "Importer depuis Microsoft 365",
        },
        googleDrive: {
          title: "Google Drive",
          desc: "Synchroniser vos documents Drive",
        },
        dropbox: {
          title: "Dropbox",
          desc: "Importer depuis votre Dropbox",
        },
        whatsapp: {
          title: "WhatsApp Business",
          desc: "Capturer les documents partagés",
        },
        manualUpload: {
          title: "Import manuel",
          desc: "PDF, images, documents Office",
        },
        connect: "Connecter",
        connected: "Connecté",
        comingSoon: "Bientôt",
        skipForNow: "Vous pourrez connecter d'autres sources plus tard",
      },
      importSettings: {
        title: "Paramètres d'import",
        subtitle: "Configurez quels documents importer automatiquement",
        period: "Période",
        periods: {
          threeMonths: "3 derniers mois",
          oneYear: "12 derniers mois",
          threeYears: "3 dernières années",
          all: "Tout l'historique",
        },
        filters: "Filtres",
        attachmentsOnly: "Uniquement avec pièces jointes",
        excludeNewsletters: "Exclure newsletters et promotions",
        smartImport: "Import intelligent",
        smartImportDesc: "Ne conserver que les documents utiles (factures, contrats, etc.)",
        fileTypes: "Types de fichiers",
        maxSize: "Taille maximum",
        estimation: "Estimation",
        documentsFound: "documents trouvés",
        estimatedSize: "Taille estimée",
        estimatedTime: "Temps estimé",
      },
      complete: {
        title: "Vous êtes prêt !",
        subtitle: "Votre espace EasyFinder est configuré",
        goToDashboard: "Accéder au tableau de bord",
      },
    },

    // Notifications
    notifications: {
      title: "Notifications",
      all: "Toutes",
      expiring: "Expirations",
      security: "Sécurité",
      noNotifications: "Aucune notification",
      markAsRead: "Marquer comme lu",
      expiringDocument: "Document bientôt expiré",
      newLogin: "Nouvelle connexion détectée",
      syncFailed: "Échec de synchronisation",
      viewDocument: "Voir le document",
      remindMe: "Me rappeler",
      reviewActivity: "Voir l'activité",
      reconnect: "Reconnecter",
    },

    // Settings
    settings: {
      title: "Paramètres",
      profile: "Profil",
      organization: "Organisation",
      connectedAccounts: "Comptes connectés",
      security: "Sécurité",
      dataControl: "Contrôle des données",
      helpSupport: "Aide et support",
      changePassword: "Changer le mot de passe",
      twoFactor: "Authentification à deux facteurs",
      twoFactorDisabled: "Non activée",
      activeSessions: "Sessions actives",
      importRules: "Règles d'import",
      ignoredDocuments: "Documents ignorés",
      exportData: "Exporter mes données",
      deleteAccount: "Supprimer mon compte",
    },

    // Settings page (detailed UI copy)
    settingsPage: {
      language: {
        title: "Langue",
        description: "Choisissez la langue de l'interface",
        switchedToFr: "Langue changée en Français",
        switchedToEn: "Language changed to English",
      },
      profile: {
        fullNameLabel: "Nom complet",
        fullNamePlaceholder: "Votre nom",
        emailLabel: "Email",
        emailReadonly: "L'email ne peut pas être modifié",
        saving: "Enregistrement...",
        save: "Enregistrer",
      },
      subscription: {
        title: "Abonnement",
        description: "Gérez votre plan et votre facturation",
        statusActive: "Actif",
        statusCanceled: "Annulé",
        statusTrial: "Essai",
        freePlanNote: "Plan gratuit avec limites",
        billing: "Facturation {cycle}",
        billingMonthly: "mensuelle",
        billingYearly: "annuelle",
      },
      billing: {
        nextBilling: "Prochaine facturation",
        manageBilling: "Gérer la facturation",
        viewPlans: "Voir les plans",
        upgrade: "Passer à un plan supérieur",
      },
      import: {
        title: "Paramètres d'import",
        description: "Gérez vos sources de données et règles d'import",
        noneConfigured: "Aucune source configurée",
        connectGmailHint: "Connectez Gmail ci-dessus pour importer automatiquement vos documents",
      },
      gmail: {
        connected: "Connecté",
        reconnectRequired: "Reconnexion requise",
        lastSync: "Dernière synchro",
        sync: "Synchroniser",
        disconnectTitle: "Déconnecter Gmail",
        reconnect: "Reconnecter",
        connect: "Connecter",
        deleteAllTitle: "Supprimer toutes les données Gmail",
        deleteAllConfirm: "Êtes-vous sûr de vouloir supprimer toutes vos données Gmail ? Cette action supprimera tous les documents importés depuis Gmail et ne peut pas être annulée.",
        deletedDocs: "{count} document(s) Gmail supprimé(s)",
        deleteError: "Erreur lors de la suppression des données Gmail",
      },
      maintenance: {
        title: "Maintenance des documents",
        description: "Outils de maintenance et correction des métadonnées",
        reanalyzeTitle: "Réanalyser tous les documents",
        reanalyzeDesc: "Relance l'extraction IA sur tous vos documents pour mettre à jour les titres, résumés et métadonnées",
        reanalyzeRunning: "Réanalyse en cours...",
        reanalyzeCta: "Lancer la réanalyse",
        processGmailTitle: "Traiter les imports Gmail en attente",
        processGmailDesc: "Analyse et rend visibles les documents Gmail importés mais non traités",
        processGmailRunning: "Traitement en cours...",
        processGmailCta: "Traiter les documents Gmail",
        deleteDuplicatesTitle: "Supprimer les doublons Gmail",
        deleteDuplicatesDesc: "Supprime les documents Gmail en double (garde le plus ancien)",
      },
    },
    // Share
    share: {
      shareDocument: "Partager le document",
      shareCollection: "Partager la collection",
      generateLink: "Générer un lien",
      copyLink: "Copier le lien",
      linkCopied: "Lien copié !",
      linkCopiedClipboard: "Lien copié dans le presse-papier",
      permissions: {
        read: "Lecture seule",
        readComment: "Lecture + commentaires",
      },
      expiration: "Expiration",
      noExpiration: "Pas d'expiration",
      password: "Mot de passe (optionnel)",
      addPassword: "Ajouter un mot de passe",
      sharedWith: "Partagé avec",
      revokeAccess: "Révoquer l'accès",
    },
    // Share Links page
    shareLinks: {
      title: "Liens de partage",
      noLinks: "Aucun lien de partage",
      noLinksDesc: "Vous n'avez pas encore partagé de documents",
      goToDocuments: "Aller aux documents",
      deletedDocument: "Document supprimé",
      expired: "Expiré",
      active: "Actif",
      protected: "Protégé",
      views: "vues",
      view: "vue",
      copyLink: "Copier le lien",
      openLink: "Ouvrir",
      revoke: "Révoquer",
      revoking: "Révocation...",
      permission: "Permission",
      readOnly: "Lecture",
      readComments: "Lecture + Commentaires",
      discussions: "Discussions",
      messages: "messages",
      message: "message",
      noMessages: "Aucun",
      created: "Créé",
      expiration: "Expiration",
      never: "Jamais",
      status: "Statut",
      document: "Document",
      stats: {
        totalLinks: "Total liens",
        activeLinks: "Liens actifs",
        totalViews: "Total vues",
        discussions: "Discussions",
      },
      discussion: {
        title: "Discussions",
        noDiscussion: "Aucune discussion",
        noDiscussionDesc: "Les personnes ayant accès à ce lien pourront commenter ici",
        replyPlaceholder: "Votre réponse...",
        you: "Vous",
        visitor: "Visiteur",
        attachment: "Pièce jointe",
      },
      deleteConfirmTitle: "Révoquer ce lien de partage ?",
      deleteConfirmDesc: "Cette action est irréversible. Les personnes ayant ce lien ne pourront plus accéder au document.",
      toasts: {
        loadError: "Erreur lors du chargement des liens",
        commentsLoadError: "Erreur lors du chargement des commentaires",
        sendError: "Erreur lors de l'envoi",
        replySent: "Réponse envoyée",
        deleteError: "Erreur lors de la suppression",
        deleteSuccess: "Lien de partage révoqué",
      },
    },

    // Errors
    errors: {
      generic: "Une erreur est survenue",
      notFound: "Page non trouvée",
      unauthorized: "Accès non autorisé",
      networkError: "Erreur de connexion",
      tryAgain: "Réessayer",
    },

    // Privacy Policy
    privacy: {
      title: "Politique de Confidentialité",
      lastUpdated: "Dernière mise à jour",
      highlights: {
        title: "Vos données sont notre priorité",
        subtitle: "EasyFinder utilise les standards de sécurité les plus élevés pour protéger vos documents",
        aes256: "Chiffrement AES-256",
        aes256Desc: "Standard militaire",
        euServers: "Serveurs en Europe",
        euServersDesc: "Conformité RGPD",
        noSale: "Aucune revente",
        noSaleDesc: "Vos données restent vôtres",
        exclusiveAccess: "Accès exclusif",
        exclusiveAccessDesc: "Vous seul y accédez",
      },
      googleApi: {
        title: "Conformité Google API - Utilisation Limitée",
        intro: "L'utilisation par EasyFinder des informations reçues des APIs Google est conforme à la",
        policy: "Google API Services User Data Policy",
        including: ", incluant les",
        limitedUse: "Limited Use requirements",
        commitments: "Nos engagements :",
        items: [
          "Les données sont utilisées uniquement pour fournir les fonctionnalités visibles d'EasyFinder",
          "Nous ne transférons jamais vos données à des tiers (publicité, courtiers de données, etc.)",
          "Nous n'utilisons jamais vos données pour de la publicité ciblée ou du retargeting",
          "Aucune lecture humaine de vos données sauf consentement explicite ou obligation légale",
          "Vos données ne sont jamais vendues ni utilisées pour évaluer votre crédit",
        ],
      },
      sections: {
        intro: {
          title: "1. Introduction",
          content: "EasyFinder accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre service. Nous nous engageons à respecter votre vie privée et à traiter vos données de manière transparente et sécurisée.",
        },
        dataCollected: {
          title: "2. Données collectées",
          intro: "Nous collectons les types de données suivants :",
          items: [
            "Données d'identification : nom, prénom, adresse email",
            "Données de connexion : logs de connexion, adresse IP (anonymisées après 30 jours)",
            "Documents : les fichiers que vous téléchargez sur notre plateforme",
            "Métadonnées : informations extraites de vos documents (dates, montants, entités)",
            "Données d'usage : statistiques d'utilisation anonymisées du service",
          ],
        },
        security: {
          title: "3. Sécurité technique",
          intro: "Nous mettons en œuvre les mesures de sécurité suivantes :",
          encryptionAtRest: "Chiffrement au repos",
          encryptionAtRestDesc: "Tous vos documents sont chiffrés avec AES-256 avant stockage. Même en cas d'accès non autorisé aux serveurs, vos données restent illisibles.",
          encryptionInTransit: "Chiffrement en transit",
          encryptionInTransitDesc: "Toutes les communications utilisent TLS 1.3 (HTTPS). Vos données sont protégées pendant leur transfert.",
          secureInfra: "Infrastructure sécurisée",
          secureInfraDesc: "Hébergement sur des serveurs Supabase en Europe (AWS eu-west), avec surveillance continue et sauvegardes régulières.",
          accessControl: "Contrôle d'accès strict",
          accessControlDesc: "Authentification sécurisée avec vérification email. Row Level Security (RLS) sur toutes les tables de données.",
        },
        ai: {
          title: "4. Traitement IA et analyse",
          intro: "EasyFinder utilise l'intelligence artificielle pour analyser et classer vos documents. Voici nos engagements :",
          items: [
            "Pas d'entraînement sur vos données : Vos documents ne sont jamais utilisés pour entraîner des modèles IA",
            "Traitement éphémère : L'analyse IA est effectuée en temps réel, sans stockage des données de traitement",
            "Fournisseurs conformes : Nos partenaires IA (Google Gemini via Lovable AI) respectent le RGPD et ne conservent pas vos données",
          ],
        },
        gmail: {
          title: "5. Intégration Gmail",
          intro: "EasyFinder peut se connecter à votre compte Gmail pour importer automatiquement vos pièces jointes importantes. Voici exactement ce que nous faisons et ne faisons pas :",
          whatWeImport: "Ce que nous importons",
          whatWeImportItems: [
            "Uniquement les pièces jointes : PDF, documents Office, images (JPG, PNG)",
            "Filtrage intelligent : seules les pièces jointes >30KB sont importées (exclut signatures email)",
            "Contexte minimal : le sujet de l'email est stocké comme référence du document",
          ],
          whatWeNeverDo: "Ce que nous ne faisons JAMAIS",
          whatWeNeverDoItems: [
            "Le contenu des emails n'est jamais lu, affiché ou stocké",
            "Aucun accès en écriture à votre boîte Gmail (scope gmail.readonly uniquement)",
            "Aucune modification, suppression ou envoi d'emails depuis votre compte",
            "Aucun partage de vos données Gmail avec des tiers",
            "Aucune utilisation de vos données pour la publicité ou l'entraînement de modèles IA",
          ],
          oauthSecurity: "Sécurité des tokens OAuth",
          oauthSecurityItems: [
            "Chiffrement AES-256-GCM : vos tokens d'accès sont chiffrés avant stockage",
            "Révocation possible : vous pouvez déconnecter Gmail à tout moment dans les Paramètres",
            "Suppression complète : le bouton \"Supprimer mes données Gmail\" efface tous les documents importés et la connexion",
          ],
          dataStored: "Données stockées",
          dataStoredItems: [
            "Fichiers des pièces jointes : stockés de façon chiffrée dans notre cloud sécurisé",
            "Métadonnées : nom du fichier, taille, date d'import, sujet de l'email source",
            "Lien de référence : URL vers l'email d'origine (pour retrouver le contexte)",
            "Token OAuth chiffré : pour les synchronisations futures (jamais en clair)",
          ],
        },
        dataUsage: {
          title: "6. Utilisation des données",
          intro: "Vos données sont utilisées exclusivement pour :",
          items: [
            "Fournir et améliorer nos services de gestion documentaire",
            "Gérer votre compte utilisateur et vos préférences",
            "Vous envoyer des notifications importantes (expiration de documents, alertes)",
            "Assurer la sécurité et la stabilité de la plateforme",
            "Analyser l'utilisation agrégée et anonymisée du service pour l'améliorer",
          ],
        },
        dataSharing: {
          title: "7. Partage des données",
          intro: "Nous ne vendons jamais vos données personnelles.",
          introSub: "Nous pouvons partager vos données uniquement avec :",
          items: [
            "Hébergeur : Supabase (serveurs AWS en Europe) pour le stockage sécurisé",
            "Paiement : Stripe pour le traitement des paiements (certifié PCI-DSS)",
            "Emails : Resend pour l'envoi de notifications",
            "IA : Google Cloud (via Lovable AI Gateway) pour l'analyse documentaire (conforme RGPD)",
          ],
          footer: "Tous nos sous-traitants sont contractuellement tenus de respecter la confidentialité de vos données.",
        },
        retention: {
          title: "8. Conservation des données",
          items: [
            "Documents : Conservés tant que votre compte est actif. Supprimés dans les 30 jours après fermeture du compte.",
            "Données de compte : Conservées 3 ans après la dernière connexion, puis anonymisées.",
            "Logs de connexion : Anonymisés après 30 jours, supprimés après 1 an.",
            "Données de facturation : Conservées 10 ans conformément aux obligations légales.",
          ],
        },
        gdpr: {
          title: "9. Vos droits (RGPD)",
          intro: "Conformément au Règlement Général sur la Protection des Données, vous disposez des droits suivants :",
          items: [
            "Droit d'accès : Obtenir une copie de toutes vos données personnelles",
            "Droit de rectification : Corriger vos données inexactes ou incomplètes",
            "Droit à l'effacement : Demander la suppression définitive de vos données",
            "Droit à la portabilité : Exporter vos données dans un format standard (JSON, CSV)",
            "Droit d'opposition : Vous opposer au traitement de vos données",
            "Droit à la limitation : Restreindre temporairement le traitement de vos données",
          ],
          footer: "Pour exercer ces droits, utilisez la fonction d'export dans les Paramètres ou contactez-nous.",
        },
        cookies: {
          title: "10. Cookies",
          content: "Nous utilisons uniquement des cookies essentiels pour le fonctionnement du service (authentification, préférences utilisateur). Aucun cookie publicitaire ou de tracking n'est utilisé.",
        },
        contact: {
          title: "11. Contact & Réclamations",
          intro: "Pour toute question concernant cette politique ou pour exercer vos droits :",
          email: "Email :",
          responseTime: "Délai de réponse : 30 jours maximum",
          cnil: "Si vous estimez que vos droits ne sont pas respectés, vous pouvez déposer une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) :",
        },
      },
      faqLink: "Consultez notre FAQ Sécurité & Confidentialité",
    },

    // Terms of Service
    terms: {
      title: "Conditions Générales d'Utilisation",
      lastUpdated: "Dernière mise à jour",
      sections: {
        object: {
          title: "1. Objet",
          content: "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service EasyFinder, une plateforme de gestion documentaire intelligente. En utilisant notre service, vous acceptez ces conditions dans leur intégralité.",
        },
        description: {
          title: "2. Description du service",
          content: "EasyFinder est un service de gestion et d'organisation de documents qui permet aux utilisateurs de stocker, classifier, rechercher et partager leurs documents. Le service inclut des fonctionnalités d'intelligence artificielle pour l'analyse et la classification automatique.",
        },
        account: {
          title: "3. Inscription et compte",
          intro: "Pour utiliser EasyFinder, vous devez :",
          items: [
            "Être âgé d'au moins 18 ans ou avoir l'autorisation d'un représentant légal",
            "Fournir des informations exactes lors de l'inscription",
            "Maintenir la confidentialité de vos identifiants de connexion",
            "Nous informer immédiatement de toute utilisation non autorisée de votre compte",
          ],
        },
        acceptableUse: {
          title: "4. Utilisation acceptable",
          intro: "Vous vous engagez à ne pas :",
          items: [
            "Télécharger des contenus illégaux, diffamatoires ou portant atteinte aux droits d'autrui",
            "Utiliser le service à des fins frauduleuses",
            "Tenter d'accéder aux comptes d'autres utilisateurs",
            "Perturber ou surcharger nos serveurs",
            "Contourner les mesures de sécurité du service",
          ],
        },
        intellectualProperty: {
          title: "5. Propriété intellectuelle",
          content: "Vous conservez tous les droits sur les documents que vous téléchargez. En utilisant EasyFinder, vous nous accordez une licence limitée pour traiter vos documents afin de fournir le service. L'interface, le code et la marque EasyFinder restent notre propriété exclusive.",
        },
        subscriptions: {
          title: "6. Abonnements et paiements",
          intro: "EasyFinder propose différentes formules d'abonnement. Les conditions suivantes s'appliquent :",
          items: [
            "Les prix sont indiqués TTC",
            "Le paiement est dû au début de chaque période de facturation",
            "Vous pouvez résilier à tout moment, l'accès reste actif jusqu'à la fin de la période payée",
            "Les remboursements sont accordés selon notre politique de remboursement",
          ],
        },
        liability: {
          title: "7. Limitation de responsabilité",
          content: "EasyFinder est fourni \"tel quel\". Nous nous efforçons d'assurer la disponibilité et la sécurité du service, mais ne pouvons garantir une disponibilité ininterrompue. Notre responsabilité est limitée au montant de votre abonnement sur les 12 derniers mois.",
        },
        termination: {
          title: "8. Résiliation",
          content: "Nous nous réservons le droit de suspendre ou résilier votre compte en cas de violation de ces CGU. Vous pouvez supprimer votre compte à tout moment depuis les paramètres.",
        },
        modifications: {
          title: "9. Modifications",
          content: "Nous pouvons modifier ces CGU à tout moment. Les modifications importantes vous seront notifiées par email. La continuation de l'utilisation du service vaut acceptation des nouvelles conditions.",
        },
        applicableLaw: {
          title: "10. Droit applicable",
          content: "Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.",
        },
        contact: {
          title: "11. Contact",
          content: "Pour toute question concernant ces CGU, contactez-nous à :",
        },
      },
      seeAlso: "Voir également notre",
      privacyPolicy: "Politique de Confidentialité",
    },
  },

  en: {
    // English translations - placeholder for future implementation
    common: {
      back: "Back",
      next: "Next",
      previous: "Previous",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      loading: "Loading...",
      search: "Search",
      filter: "Filter",
      download: "Download",
      share: "Share",
      upload: "Upload",
      confirm: "Confirm",
      skip: "Skip",
      continue: "Continue",
      getStarted: "Get Started",
      learnMore: "Learn More",
      viewAll: "View All",
      manage: "Manage",
      signIn: "Sign in",
      signUp: "Sign up",
      signOut: "Sign out",
      or: "or",
      free: "Free",
      perMonth: "/month",
      perYear: "/year",
      popular: "Popular",
      recommended: "Recommended",
    },
    landing: {
      nav: {
        features: "Features",
        howItWorks: "How it works",
        pricing: "Pricing",
        signIn: "Sign in",
        getStarted: "Get started",
        startFree: "Start for free",
      },
      hero: {
        badge: "Powered by artificial intelligence",
        title1: "Organize less.",
        title2: "Find everything.",
        subtitle: "EasyFinder centralizes your documents, automatically classifies them, and lets you find anything in seconds with intelligent search.",
        cta: "Try for free",
        watchDemo: "Watch demo",
        users: "+2,000 users",
        reviews: "4.9/5 (150+ reviews)",
        searchPlaceholder: "Where is my 2023 tax return?",
      },
      howItWorks: {
        title: "Simple as can be",
        subtitle: "Three steps to never lose a document again",
        steps: [
          { title: "Import your documents", desc: "Connect Gmail, Outlook, or drop your files directly." },
          { title: "AI does the rest", desc: "Automatic classification, date and key information extraction." },
          { title: "Search naturally", desc: "\"My EDF invoice from March\" — and there it is." },
        ],
      },
      features: {
        title: "Everything you need",
        subtitle: "Tools designed to save you time",
        items: [
          { title: "Smart search", desc: "Ask a question in plain English, find your document." },
          { title: "Auto-classification", desc: "Invoices, contracts, taxes... AI sorts for you." },
          { title: "Maximum security", desc: "End-to-end encryption, European hosting." },
          { title: "Complete PDF tools", desc: "Merge, annotate and sign your documents." },
          { title: "Smart scanner", desc: "Take a photo, AI digitizes and classifies automatically." },
          { title: "Secure sharing", desc: "Password-protected links with expiration." },
        ],
      },
      testimonials: {
        title: "They've adopted EasyFinder",
        subtitle: "Discover why they can't live without it",
        items: [
          { quote: "No more hours lost searching for my invoices. In 3 seconds, I find everything I need.", name: "Marie L.", role: "Freelance Designer" },
          { quote: "The automatic classification is amazing. I imported 500 documents, everything was sorted in 2 minutes.", name: "Thomas D.", role: "Entrepreneur" },
          { quote: "Secure sharing with my clients has transformed my daily routine. Professional and efficient.", name: "Sophie M.", role: "Lawyer" },
        ],
      },
      pricing: {
        title: "Simple pricing, no surprises",
        subtitle: "Start free, upgrade when you're ready",
        mostPopular: "Most popular",
        perMonth: "/month",
        cta: "Get started",
        cancelAnytime: "Cancel anytime. Save 20% with annual billing.",
        plans: [
          { name: "Discovery", desc: "To try it out", features: ["30 documents", "1 connected source", "10 AI searches/day", "5 PDF actions/month"] },
          { name: "Personal", desc: "For individuals", features: ["500 documents", "1 connected source", "50 AI searches/day", "20 PDF actions/month"] },
          { name: "Pro", desc: "For freelancers", features: ["2,500 documents", "2 connected sources", "Unlimited AI searches", "Unlimited PDF actions", "ZIP export"] },
          { name: "Business", desc: "For teams", features: ["10,000 documents", "Unlimited sources", "3 users included", "Role management"] },
        ],
      },
      cta: {
        title: "Ready to take back control?",
        subtitle: "Join thousands of users who have finally found document peace of mind.",
        button: "Start for free",
      },
      footer: {
        securityFaq: "Security FAQ",
        privacy: "Privacy Policy",
        terms: "Terms",
        legal: "Legal Notice",
      },
    },
    auth: {
      createAccount: "Create your account",
      welcomeBack: "Welcome back",
      startOrganizing: "Start organizing your documents",
      signInAccess: "Sign in to access your documents",
      fullName: "Full name",
      email: "Email",
      password: "Password",
      createAccountBtn: "Create account",
      signInBtn: "Sign in",
      orContinueWith: "Or continue with",
      continueWithGoogle: "Continue with Google",
      continueWithApple: "Continue with Apple",
      alreadyHaveAccount: "Already have an account?",
      noAccount: "Don't have an account?",
      forgotPassword: "Forgot password?",
      checkEmail: "Check your email",
      confirmationSent: "We've sent a confirmation link to",
      clickToActivate: "Click the link in the email to activate your account and start using EasyFinder.",
      confirmedEmail: "I've confirmed my email",
      noEmailReceived: "Didn't receive the email?",
      resend: "Resend",
      welcomeBackToast: "Welcome back!",
      invalidCredentials: "Invalid email or password",
      emailInUse: "This email is already in use",
      confirmEmailFirst: "Please confirm your email before signing in",
      genericError: "An error occurred",
      resendError: "Error resending email",
      resendSuccess: "Confirmation email resent!",
      googleNotConfigured: "Google sign-in not configured yet",
      validation: {
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format",
        emailTooLong: "Email must not exceed 255 characters",
        emailFormat: "Email format not allowed",
        passwordMin: "Password must be at least 8 characters",
        passwordMax: "Password must not exceed 128 characters",
        passwordUppercase: "Password must contain at least one uppercase letter",
        passwordLowercase: "Password must contain at least one lowercase letter",
        passwordDigit: "Password must contain at least one digit",
        passwordSpecial: "Password must contain at least one special character",
        passwordRequired: "Password is required",
        nameMin: "Name must be at least 2 characters",
        nameMax: "Name must not exceed 100 characters",
        nameFormat: "Name must contain only letters",
      },
    },

    // Pricing
    pricing: {
      launchOffer: "Launch offer: Pro at €19.90/month for the first 500",
      title: "Choose your plan",
      subtitle: "Start free, scale as you grow",
      monthly: "Monthly",
      yearly: "Yearly",
      monthsFree: "2 months free",
      mostPopular: "Most popular",
      billedAnnually: "Billed annually",
      saveWith: "Save",
      withAnnual: "/year with annual",
      documents: "Documents",
      sources: "Sources",
      aiSearchesDay: "AI searches/day",
      pdfActionsMonth: "PDF actions/month",
      unlimited: "Unlimited",
      all: "All",
      moreFeatures: "more features",
      currentPlan: "Current plan",
      startFree: "Start for free",
      choosePlan: "Choose this plan",
      redirecting: "Redirecting...",
      allPlansInclude: "All plans include: data encryption, email support, automatic updates",
      faq: {
        title: "Frequently asked questions",
        items: [
          { q: "Is the Discovery plan really free?", a: "Yes! The Discovery plan is free forever with 30 documents, 10 AI searches per day and essential features." },
          { q: "Can I change plans anytime?", a: "Absolutely. You can upgrade or downgrade your plan whenever you want. The difference will be prorated." },
          { q: "Is my data secure?", a: "Yes, your documents are encrypted and securely stored. We are GDPR compliant and never share your data." },
          { q: "How does annual billing work?", a: "With annual billing, you save about 2 months. Payment is made once for the year." },
        ],
      },
      footer: "All rights reserved.",
      toasts: {
        freeNoPayment: "This plan is free, no payment needed",
        paymentUrlError: "Payment URL not received",
        paymentError: "Error creating payment",
      },
    },
    dashboard: {
      welcomeBack: "Welcome back",
      whatLookingFor: "What are you looking for today?",
      findManage: "Find and manage your documents",
      searchPlaceholder: "What are you looking for? Try 'tax return 2023' or 'March invoices'...",
      upload: "Upload",
      browseAll: "Browse all",
      connectedSources: "Connected sources",
      recentDocuments: "Recent documents",
      viewAll: "View all",
      noDocuments: "No documents",
      uploadFirst: "Upload your first document to get started",
      welcome: "Welcome to EasyFinder 🎉",
      startWithDocs: "Start by adding your first documents",
      scanDocument: "Scan a document",
      scanDesc: "Use your camera to digitize",
      importFiles: "Import files",
      importDesc: "PDF, images, Word documents...",
      connectEmail: "Connect your email",
      connectEmailDesc: "Automatically import your attachments",
      placeholders: [
        "My invoices over 500 euros",
        "Contracts signed in 2024",
        "Vehicle documents",
        "Employment certificates",
        "Recent bank statements",
      ],
      expiration: {
        expired: "Expired since",
        today: "Expires today",
        days: "Expires in",
        daysUnit: "d",
      },
      toasts: {
        voiceNotSupported: "Voice recognition is not supported",
        aiLimitReached: "AI search limit reached",
        signOutSuccess: "Signed out successfully",
        alertRemoved: "Alert removed",
      },
    },
    documents: {
      allDocuments: "All documents",
      searchDocuments: "Search documents...",
      type: "Type",
      source: "Source",
      category: "Category",
      allTypes: "All types",
      allSources: "All sources",
      allCategories: "All categories",
      allCategoriesShort: "All",
      documentsCount: "documents",
      noResults: "No documents found",
      scanner: "Scanner",
      import: "Import",
      alerts: "Alerts",
      cleanDuplicates: "Clean duplicates",
      select: "Select",
      selectAll: "Select all",
      cancelSelection: "Cancel",
      selected: "selected",
      deleteSelection: "Delete selection",
      share: "Share",
      edit: "Edit",
      delete: "Delete",
      openSource: "Open original source",
      page: "Page",
      sessionExpired: "Session expired, please sign in again",
      loadError: "Unable to load your documents",
      toasts: {
        deleteFileError: "Error deleting files",
        deleteError: "Error deleting",
        deleteSuccess: "Document deleted",
        deleteBulkSuccess: "document(s) deleted",
        downloadError: "Error downloading",
        extracting: "Extracting text...",
        extractError: "Error extracting",
        extractOcrError: "Error during OCR extraction",
        extractSuccess: "Text extracted successfully!",
        noDuplicates: "No duplicates found!",
        noSelected: "No duplicates selected",
        duplicatesDeleted: "duplicate(s) deleted",
        aiSearchError: "Error during AI search",
      },
      types: {
        invoice: "Invoice",
        contract: "Contract",
        tax: "Tax",
        insurance: "Insurance",
        identity: "Identity",
        receipt: "Receipt",
        quote: "Quote",
        payslip: "Payslip",
        attestation: "Certificate",
        bank_statement: "Bank statement",
        medical_certificate: "Medical certificate",
        notarial_deed: "Notarial deed",
        administrative: "Administrative",
        warranty: "Warranty",
        other: "Other",
      },
      sources: {
        gmail: "Gmail",
        outlook: "Outlook",
        whatsapp: "WhatsApp",
        upload: "Upload",
      },
      statuses: {
        processing: "Processing",
        complete: "Complete",
        failed: "Failed",
        important: "Important",
        to_verify: "To verify",
        archived: "Archived",
      },
    },
    pdf: {
      pageTitle: "PDF Tools",
      viewer: "PDF Viewer",
      merge: "Merge PDFs",
      sign: "Sign Document",
      scan: "Scan Document",
      selectFiles: "Select files",
      dragDrop: "Drag and drop your files here",
      mergeDescription: "Combine multiple PDFs into one document",
      signDescription: "Add your signature to a document",
      scanDescription: "Digitize a document with your camera",
      processing: "Processing...",
      download: "Download result",
      addSignature: "Add signature",
      drawSignature: "Draw your signature",
      clearSignature: "Clear",
      applySignature: "Apply signature",
      capturePhoto: "Capture photo",
      retake: "Retake",
      usePhoto: "Use this photo",
      initializingScanner: "Initializing smart scanner...",
      loadingAutoDetection: "Loading automatic detection",
      documentDetected: "Document detected - Capturing...",
      holdSteady: "Hold the document steady...",
      positionDocument: "Position the document in the frame",
      autoCaptureHint: "The document will be captured automatically once detected and stable",
    },

    // Not Found
    notFound: {
      title: "Page not found",
      message: "Oops! This page doesn't exist",
      backHome: "Back to Home",
    },

    // Reset Password
    resetPassword: {
      title: "New password",
      subtitle: "Choose a secure password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      submit: "Update password",
      submitting: "Updating...",
      success: "Password updated",
      successMessage: "Your password has been changed successfully. Redirecting...",
      invalidLink: "Invalid or expired reset link",
      passwordMismatch: "Passwords do not match",
      samePassword: "New password must be different from the old one",
      updateError: "An error occurred during update",
      updateSuccess: "Password updated successfully!",
    },


    onboarding: {
      step: "Step",
      of: "of",
      accountType: {
        title: "Who will use EasyFinder?",
        subtitle: "This determines if you create a shared organization or not",
        individual: {
          title: "Just me",
          desc: "Personal use, single user. All plans available.",
        },
        team: {
          title: "My team",
          desc: "Create an organization to invite collaborators and share documents.",
        },
      },
      organization: {
        title: "Create your organization",
        subtitle: "This information will be visible to your team members",
        name: "Organization name",
        namePlaceholder: "My company",
        domain: "Domain (optional)",
        domainPlaceholder: "mycompany.com",
        logo: "Logo (optional)",
        uploadLogo: "Upload logo",
      },
      plan: {
        title: "Choose your plan",
        subtitle: "Start free, upgrade when ready",
        monthly: "Monthly",
        yearly: "Yearly",
        yearlyDiscount: "2 months free",
        currentPlan: "Current plan",
        choosePlan: "Choose this plan",
        startFree: "Start free",
      },
      sources: {
        title: "Connect your sources",
        subtitle: "Automatically import documents from your services",
        emailCategory: "Emails",
        cloudCategory: "Cloud storage",
        otherCategory: "Other sources",
        gmail: {
          title: "Gmail",
          desc: "Import attachments from your emails",
        },
        outlook: {
          title: "Outlook",
          desc: "Import from Microsoft 365",
        },
        googleDrive: {
          title: "Google Drive",
          desc: "Sync your Drive documents",
        },
        dropbox: {
          title: "Dropbox",
          desc: "Import from your Dropbox",
        },
        whatsapp: {
          title: "WhatsApp Business",
          desc: "Capture shared documents",
        },
        manualUpload: {
          title: "Manual upload",
          desc: "PDFs, images, Office documents",
        },
        connect: "Connect",
        connected: "Connected",
        comingSoon: "Soon",
        skipForNow: "You can connect other sources later",
      },
      importSettings: {
        title: "Import settings",
        subtitle: "Configure which documents to import automatically",
        period: "Period",
        periods: {
          threeMonths: "Last 3 months",
          oneYear: "Last 12 months",
          threeYears: "Last 3 years",
          all: "All history",
        },
        filters: "Filters",
        attachmentsOnly: "Only with attachments",
        excludeNewsletters: "Exclude newsletters and promotions",
        smartImport: "Smart import",
        smartImportDesc: "Only keep useful documents (invoices, contracts, etc.)",
        fileTypes: "File types",
        maxSize: "Maximum size",
        estimation: "Estimation",
        documentsFound: "documents found",
        estimatedSize: "Estimated size",
        estimatedTime: "Estimated time",
      },
      complete: {
        title: "You're all set!",
        subtitle: "Your EasyFinder workspace is configured",
        goToDashboard: "Go to dashboard",
      },
    },
    notifications: {
      title: "Notifications",
      all: "All",
      expiring: "Expiring",
      security: "Security",
      noNotifications: "No notifications",
      markAsRead: "Mark as read",
      expiringDocument: "Document expiring soon",
      newLogin: "New login detected",
      syncFailed: "Sync failed",
      viewDocument: "View document",
      remindMe: "Remind me",
      reviewActivity: "Review activity",
      reconnect: "Reconnect",
    },
    settings: {
      title: "Settings",
      profile: "Profile",
      organization: "Organization",
      connectedAccounts: "Connected accounts",
      security: "Security",
      dataControl: "Data control",
      helpSupport: "Help & Support",
      changePassword: "Change password",
      twoFactor: "Two-factor authentication",
      twoFactorDisabled: "Not enabled",
      activeSessions: "Active sessions",
      importRules: "Import rules",
      ignoredDocuments: "Ignored documents",
      exportData: "Export my data",
      deleteAccount: "Delete my account",
    },

    // Settings page (detailed UI copy)
    settingsPage: {
      language: {
        title: "Language",
        description: "Choose the interface language",
        switchedToFr: "Language changed to French",
        switchedToEn: "Language changed to English",
      },
      profile: {
        fullNameLabel: "Full name",
        fullNamePlaceholder: "Your name",
        emailLabel: "Email",
        emailReadonly: "Email can't be changed",
        saving: "Saving...",
        save: "Save",
      },
      subscription: {
        title: "Subscription",
        description: "Manage your plan and billing",
        statusActive: "Active",
        statusCanceled: "Canceled",
        statusTrial: "Trial",
        freePlanNote: "Free plan with limits",
        billing: "Billing {cycle}",
        billingMonthly: "monthly",
        billingYearly: "yearly",
      },
      billing: {
        nextBilling: "Next billing date",
        manageBilling: "Manage billing",
        viewPlans: "View plans",
        upgrade: "Upgrade plan",
      },
      import: {
        title: "Import settings",
        description: "Manage your data sources and import rules",
        noneConfigured: "No source configured",
        connectGmailHint: "Connect Gmail above to automatically import your documents",
      },
      gmail: {
        connected: "Connected",
        reconnectRequired: "Reconnect required",
        lastSync: "Last sync",
        sync: "Sync",
        disconnectTitle: "Disconnect Gmail",
        reconnect: "Reconnect",
        connect: "Connect",
        deleteAllTitle: "Delete all Gmail data",
        deleteAllConfirm: "Are you sure you want to delete all your Gmail data? This will delete all documents imported from Gmail and cannot be undone.",
        deletedDocs: "{count} Gmail document(s) deleted",
        deleteError: "Error deleting Gmail data",
      },
      maintenance: {
        title: "Document maintenance",
        description: "Maintenance tools and metadata corrections",
        reanalyzeTitle: "Reanalyze all documents",
        reanalyzeDesc: "Reruns AI extraction on all your documents to update titles, summaries and metadata",
        reanalyzeRunning: "Reanalyzing...",
        reanalyzeCta: "Start reanalysis",
        processGmailTitle: "Process pending Gmail imports",
        processGmailDesc: "Analyzes and makes visible Gmail documents that were imported but not processed",
        processGmailRunning: "Processing...",
        processGmailCta: "Process Gmail documents",
        deleteDuplicatesTitle: "Delete Gmail duplicates",
        deleteDuplicatesDesc: "Deletes duplicate Gmail documents (keeps the oldest)",
      },
    },
    share: {
      shareDocument: "Share document",
      shareCollection: "Share collection",
      generateLink: "Generate link",
      copyLink: "Copy link",
      linkCopied: "Link copied!",
      linkCopiedClipboard: "Link copied to clipboard",
      permissions: {
        read: "Read only",
        readComment: "Read + comments",
      },
      expiration: "Expiration",
      noExpiration: "No expiration",
      password: "Password (optional)",
      addPassword: "Add password",
      sharedWith: "Shared with",
      revokeAccess: "Revoke access",
    },
    shareLinks: {
      title: "Share links",
      noLinks: "No share links",
      noLinksDesc: "You haven't shared any documents yet",
      goToDocuments: "Go to documents",
      deletedDocument: "Deleted document",
      expired: "Expired",
      active: "Active",
      protected: "Protected",
      views: "views",
      view: "view",
      copyLink: "Copy link",
      openLink: "Open",
      revoke: "Revoke",
      revoking: "Revoking...",
      permission: "Permission",
      readOnly: "Read only",
      readComments: "Read + Comments",
      discussions: "Discussions",
      messages: "messages",
      message: "message",
      noMessages: "None",
      created: "Created",
      expiration: "Expiration",
      never: "Never",
      status: "Status",
      document: "Document",
      stats: {
        totalLinks: "Total links",
        activeLinks: "Active links",
        totalViews: "Total views",
        discussions: "Discussions",
      },
      discussion: {
        title: "Discussions",
        noDiscussion: "No discussion",
        noDiscussionDesc: "People with access to this link can comment here",
        replyPlaceholder: "Your reply...",
        you: "You",
        visitor: "Visitor",
        attachment: "Attachment",
      },
      deleteConfirmTitle: "Revoke this share link?",
      deleteConfirmDesc: "This action is irreversible. People with this link will no longer be able to access the document.",
      toasts: {
        loadError: "Error loading links",
        commentsLoadError: "Error loading comments",
        sendError: "Error sending",
        replySent: "Reply sent",
        deleteError: "Error deleting",
        deleteSuccess: "Share link revoked",
      },
    },
    errors: {
      generic: "An error occurred",
      notFound: "Page not found",
      unauthorized: "Unauthorized access",
      networkError: "Connection error",
      tryAgain: "Try again",
    },

    // Privacy Policy
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last updated",
      highlights: {
        title: "Your data is our priority",
        subtitle: "EasyFinder uses the highest security standards to protect your documents",
        aes256: "AES-256 Encryption",
        aes256Desc: "Military-grade standard",
        euServers: "European Servers",
        euServersDesc: "GDPR Compliant",
        noSale: "No Data Sale",
        noSaleDesc: "Your data stays yours",
        exclusiveAccess: "Exclusive Access",
        exclusiveAccessDesc: "Only you can access it",
      },
      googleApi: {
        title: "Google API Compliance - Limited Use",
        intro: "EasyFinder's use of information received from Google APIs adheres to the",
        policy: "Google API Services User Data Policy",
        including: ", including the",
        limitedUse: "Limited Use requirements",
        commitments: "Our commitments:",
        items: [
          "Data is used only to provide user-facing features visible in EasyFinder",
          "We never transfer your data to third parties (advertising, data brokers, etc.)",
          "We never use your data for targeted advertising or retargeting",
          "No human reading of your data except with explicit consent or legal obligation",
          "Your data is never sold or used to assess your creditworthiness",
        ],
      },
      sections: {
        intro: {
          title: "1. Introduction",
          content: "EasyFinder places great importance on protecting your personal data. This privacy policy describes how we collect, use, and protect your information when you use our service. We are committed to respecting your privacy and processing your data transparently and securely.",
        },
        dataCollected: {
          title: "2. Data Collected",
          intro: "We collect the following types of data:",
          items: [
            "Identification data: name, surname, email address",
            "Connection data: login logs, IP address (anonymized after 30 days)",
            "Documents: files you upload to our platform",
            "Metadata: information extracted from your documents (dates, amounts, entities)",
            "Usage data: anonymized service usage statistics",
          ],
        },
        security: {
          title: "3. Technical Security",
          intro: "We implement the following security measures:",
          encryptionAtRest: "Encryption at Rest",
          encryptionAtRestDesc: "All your documents are encrypted with AES-256 before storage. Even in case of unauthorized server access, your data remains unreadable.",
          encryptionInTransit: "Encryption in Transit",
          encryptionInTransitDesc: "All communications use TLS 1.3 (HTTPS). Your data is protected during transfer.",
          secureInfra: "Secure Infrastructure",
          secureInfraDesc: "Hosted on Supabase servers in Europe (AWS eu-west), with continuous monitoring and regular backups.",
          accessControl: "Strict Access Control",
          accessControlDesc: "Secure authentication with email verification. Row Level Security (RLS) on all data tables.",
        },
        ai: {
          title: "4. AI Processing and Analysis",
          intro: "EasyFinder uses artificial intelligence to analyze and classify your documents. Here are our commitments:",
          items: [
            "No training on your data: Your documents are never used to train AI models",
            "Ephemeral processing: AI analysis is performed in real-time, without storing processing data",
            "Compliant providers: Our AI partners (Google Gemini via Lovable AI) respect GDPR and do not retain your data",
          ],
        },
        gmail: {
          title: "5. Gmail Integration",
          intro: "EasyFinder can connect to your Gmail account to automatically import your important attachments. Here's exactly what we do and don't do:",
          whatWeImport: "What we import",
          whatWeImportItems: [
            "Attachments only: PDFs, Office documents, images (JPG, PNG)",
            "Smart filtering: only attachments >30KB are imported (excludes email signatures)",
            "Minimal context: email subject is stored as document reference",
          ],
          whatWeNeverDo: "What we NEVER do",
          whatWeNeverDoItems: [
            "Email content is never read, displayed, or stored",
            "No write access to your Gmail inbox (gmail.readonly scope only)",
            "No modification, deletion, or sending of emails from your account",
            "No sharing of your Gmail data with third parties",
            "No use of your data for advertising or AI model training",
          ],
          oauthSecurity: "OAuth Token Security",
          oauthSecurityItems: [
            "AES-256-GCM encryption: your access tokens are encrypted before storage",
            "Revocation possible: you can disconnect Gmail at any time in Settings",
            "Complete deletion: the \"Delete my Gmail data\" button erases all imported documents and connection",
          ],
          dataStored: "Data Stored",
          dataStoredItems: [
            "Attachment files: stored encrypted in our secure cloud",
            "Metadata: file name, size, import date, source email subject",
            "Reference link: URL to original email (to retrieve context)",
            "Encrypted OAuth token: for future synchronizations (never in plain text)",
          ],
        },
        dataUsage: {
          title: "6. Data Usage",
          intro: "Your data is used exclusively for:",
          items: [
            "Providing and improving our document management services",
            "Managing your user account and preferences",
            "Sending you important notifications (document expiration, alerts)",
            "Ensuring platform security and stability",
            "Analyzing aggregated and anonymized service usage for improvement",
          ],
        },
        dataSharing: {
          title: "7. Data Sharing",
          intro: "We never sell your personal data.",
          introSub: "We may share your data only with:",
          items: [
            "Hosting: Supabase (AWS servers in Europe) for secure storage",
            "Payments: Stripe for payment processing (PCI-DSS certified)",
            "Emails: Resend for sending notifications",
            "AI: Google Cloud (via Lovable AI Gateway) for document analysis (GDPR compliant)",
          ],
          footer: "All our subcontractors are contractually bound to respect the confidentiality of your data.",
        },
        retention: {
          title: "8. Data Retention",
          items: [
            "Documents: Retained while your account is active. Deleted within 30 days after account closure.",
            "Account data: Retained 3 years after last login, then anonymized.",
            "Connection logs: Anonymized after 30 days, deleted after 1 year.",
            "Billing data: Retained 10 years in accordance with legal obligations.",
          ],
        },
        gdpr: {
          title: "9. Your Rights (GDPR)",
          intro: "In accordance with the General Data Protection Regulation, you have the following rights:",
          items: [
            "Right of access: Obtain a copy of all your personal data",
            "Right of rectification: Correct your inaccurate or incomplete data",
            "Right to erasure: Request permanent deletion of your data",
            "Right to portability: Export your data in a standard format (JSON, CSV)",
            "Right to object: Object to the processing of your data",
            "Right to restriction: Temporarily restrict the processing of your data",
          ],
          footer: "To exercise these rights, use the export function in Settings or contact us.",
        },
        cookies: {
          title: "10. Cookies",
          content: "We only use essential cookies for service operation (authentication, user preferences). No advertising or tracking cookies are used.",
        },
        contact: {
          title: "11. Contact & Complaints",
          intro: "For any questions regarding this policy or to exercise your rights:",
          email: "Email:",
          responseTime: "Response time: 30 days maximum",
          cnil: "If you believe your rights are not being respected, you can file a complaint with the CNIL (French Data Protection Authority):",
        },
      },
      faqLink: "View our Security & Privacy FAQ",
    },

    // Terms of Service
    terms: {
      title: "Terms of Service",
      lastUpdated: "Last updated",
      sections: {
        object: {
          title: "1. Purpose",
          content: "These Terms of Service govern the use of the EasyFinder service, an intelligent document management platform. By using our service, you accept these terms in their entirety.",
        },
        description: {
          title: "2. Service Description",
          content: "EasyFinder is a document management and organization service that allows users to store, classify, search, and share their documents. The service includes artificial intelligence features for automatic analysis and classification.",
        },
        account: {
          title: "3. Registration and Account",
          intro: "To use EasyFinder, you must:",
          items: [
            "Be at least 18 years old or have authorization from a legal guardian",
            "Provide accurate information during registration",
            "Maintain the confidentiality of your login credentials",
            "Notify us immediately of any unauthorized use of your account",
          ],
        },
        acceptableUse: {
          title: "4. Acceptable Use",
          intro: "You agree not to:",
          items: [
            "Upload illegal, defamatory content or content infringing on others' rights",
            "Use the service for fraudulent purposes",
            "Attempt to access other users' accounts",
            "Disrupt or overload our servers",
            "Circumvent the service's security measures",
          ],
        },
        intellectualProperty: {
          title: "5. Intellectual Property",
          content: "You retain all rights to the documents you upload. By using EasyFinder, you grant us a limited license to process your documents to provide the service. The interface, code, and EasyFinder brand remain our exclusive property.",
        },
        subscriptions: {
          title: "6. Subscriptions and Payments",
          intro: "EasyFinder offers different subscription plans. The following conditions apply:",
          items: [
            "Prices include all taxes",
            "Payment is due at the beginning of each billing period",
            "You can cancel at any time, access remains active until the end of the paid period",
            "Refunds are granted according to our refund policy",
          ],
        },
        liability: {
          title: "7. Limitation of Liability",
          content: "EasyFinder is provided \"as is\". We strive to ensure service availability and security but cannot guarantee uninterrupted availability. Our liability is limited to the amount of your subscription over the last 12 months.",
        },
        termination: {
          title: "8. Termination",
          content: "We reserve the right to suspend or terminate your account in case of violation of these Terms. You can delete your account at any time from settings.",
        },
        modifications: {
          title: "9. Modifications",
          content: "We may modify these Terms at any time. Significant changes will be notified to you by email. Continued use of the service constitutes acceptance of the new terms.",
        },
        applicableLaw: {
          title: "10. Applicable Law",
          content: "These Terms are governed by French law. In case of dispute, French courts shall have exclusive jurisdiction.",
        },
        contact: {
          title: "11. Contact",
          content: "For any questions regarding these Terms, contact us at:",
        },
      },
      seeAlso: "See also our",
      privacyPolicy: "Privacy Policy",
    },
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.fr;
